module.exports = __webpack_public_path__ + "assets/img/Shape.986265f7.png";